
import loader from '@/components/loader'
export default {
    layout: 'news',
    components: {
        loader
    },
    mounted: function () {
        this.$parent.$emit("sentNewsDate", this.news  && this.news.news_date ? this.news.news_date : '');
        this.$parent.$emit("sentTitle", this.getPageTitle());
        // this.$parent.$emit("sentSubTitle", 'What is an MOT Check?');
    },
    scrollToTop: true,
    data() {
        return {
            newsName: null,
            news: null,
            loading: true
        };
    },
    head() {
        return {
            title: this.getPageTitle(),
            meta: [
                {
                    hid: "og:title",
                    property: "og:title",
                    content: this.getPageMetaTitle()
                },
                {
                    hid: "twitter:title",
                    property: "twitter:title",
                    content: this.getPageMetaTitle()
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: this.getPageMetaDesc()
                },
                {
                    hid: 'description',
                    property: 'description',
                    content: this.getPageMetaDesc()
                },
                {
                    hid: 'twitter:description',
                    property: 'twitter:description',
                    content: this.getPageMetaDesc()
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: this.getPageMetaKeywords()
                },
            ],
        };
    },
    async validate({ params, store }) {
        // await operations
        if (params.slug != (null || "")) {
            this.newsName = params.slug;
            return true; // if the params are valid
        }
        else {
            return false; // will stop Nuxt.js to render the route and display the error page
        }
    },
    created() {
        this.newsName = this.$route.params.slug;
    },
    async fetch() {
        // Get station data
        this.news = await fetch(this.$config.fetchUrl + "/api/blogs/getBlog/" + this.newsName).then(res => res.json()).catch(error => {
            console.error("There was an error!", error);
            this.$router.push({
                path: "/"
            });
        });
        this.$parent.$emit("sentNewsDate", this.news ? this.news.news_date : '');
        this.$parent.$emit("sentTitle", this.getPageTitle());
        console.log(this.news)

        this.loading = false;
    },

    mounted(){
        this.formatNewsDesc()
    },

    methods: {
        formatNewsDesc(){
            if(this.news && this.news.news_item){
            console.log(this.news.news_item)
        this.news.news_item = this.news.news_item.replaceAll('\n','');
        this.news.news_item = this.news.news_item.replaceAll('<p>&nbsp;</p>','');
        this.news.news_item = this.news.news_item.replaceAll('<h1>&nbsp;</h1>','');
        this.news.news_item = this.news.news_item.replaceAll('<h2>&nbsp;</h2>','');
        }
        },
        getPageTitle() {
            if (this.news && this.news.page_meta_title)
                return this.news.news_title
            return 'MOT Check News'
        },
        getPageDesc() {
            if (this.news && this.news.page_meta_description)
                return this.news.page_meta_description
            return 'MOT Check News'
        },
        getPageMetaTitle() {
            if (this.news && this.news.page_meta_title)
                return this.news.page_meta_title
            return 'MOT Check News'
        },
        getPageMetaDesc() {
            if (this.news && this.news.page_meta_description)
                return this.news.page_meta_description
            return 'MOT Check News'
        },
        getPageMetaKeywords() {
            if (this.news && this.news.page_meta_keywords)
                return this.news.page_meta_keywords
            return 'MOT Check News'
        }
    }
};

